<script>
  import { onMount } from 'svelte';

  export let placeholder;
  export let options;
  export let chosenOpt = '';
  export let error;

  let dropdown;
  let dropdownButton;
  let dropdownOptions;

  onMount(() => {
    dropdownOptions = document.querySelectorAll('.form-dropdown-option');
    window.addEventListener('click', removeDropdown);

    return () => {
      // console.log("Removing listener");
      // console.log(windowListener);
      window.removeEventListener('click', removeDropdown);
    };
  });

  /**
   * @desc Toggles custom dropdown menu
   * @param object
   * @return null
   */
  const handleDropdownClick = (e) => {
    dropdownButton = e.target;
    dropdown.classList.toggle('form-dropdown-expanded');
    if (dropdownButton.classList.contains('form-invalid')) {
      dropdown.classList.add('form-dropdown-expanded-invalid');
    }
  };

  /**
   * @desc Checks to see if any of the dropdown options have been clicked
   * @param array [object], object
   * @return boolean
   */
  const cycleOptions = (nodes, target) => {
    let found = false;
    nodes.forEach((node) => {
      if (node === target) {
        found = true;
      }
    });
    return found;
  };

  /**
   * @desc Closes dropdown menu if click registered outside
   * @param null
   * @return null
   */
  const removeDropdown = (e) => {
    if (
      (e.target !== dropdownButton) &
      !cycleOptions(dropdownOptions, e.target)
    ) {
      dropdown.classList.remove('form-dropdown-expanded');
    }
  };

  /**
   * @desc Selects dropdown option and adds value to hidden input value
   * @param null
   * @return null
   */
  const handleOptionSelect = (e) => {
    chosenOpt = e.target.innerText;
    dropdownButton.classList.add('form-dropdown-selected');
    dropdown.classList.remove('form-dropdown-expanded');
  };
</script>

<label for="hear-about-us" class="form-label">{placeholder}</label>
<div class="form-dropdown" id="hear-about-us" bind:this={dropdown}>
  <div
    class="form-input form-dropdown-select{chosenOpt === '' ? '' : ' form-dropdown-selected'}{error ? ' form-invalid' : ''}"
    on:click={handleDropdownClick}>
    <p class="">{chosenOpt === '' ? placeholder : chosenOpt}</p>
    <i class="fas fa-chevron-down" />
  </div>
  <ul class="form-dropdown-options body">
    {#each options as option}
      <li class="form-dropdown-option" on:click={handleOptionSelect}>
        {option}
      </li>
    {/each}
    <ul />
  </ul>
</div>
